import {
  HomeOutlined,
  UserOutlined,
  ShopOutlined,
  UnorderedListOutlined,
  BookOutlined,
  AppstoreOutlined,
  DollarOutlined,
} from "@ant-design/icons";
import { Menu } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";

const SuperAdminSidenav = ({ color, collapsed = false }) => {
  const { pathname } = useLocation();

  const selectedKey = (() => {
    if (pathname === "/super-admin/dashboard") return "superAdminDashboard";
    if (pathname === "/super-admin/users") return "userManagement";
    if (pathname === "/super-admin/companies") return "companyManagement";
    if (pathname === "/super-admin/products") return "products";
    if (pathname === "/super-admin/book-publishers") return "bookPublishers";
    if (pathname === "/super-admin/product-categories") return "productCategories";
    if (pathname === "/super-admin/product-currencies") return "productCurrencies";
    return undefined;
  })();

  const parentKey = useMemo(() => {
    if (!selectedKey) return null;
    if (["products", "bookPublishers", "productCategories", "productCurrencies"].includes(selectedKey)) return "masterData";
    return null;
  }, [selectedKey]);

  const [openKeys, setOpenKeys] = useState(parentKey ? [parentKey] : []);
  useEffect(() => {
    setOpenKeys(parentKey ? [parentKey] : []);
  }, [parentKey]);

  const menuSelectedKeys = selectedKey ? [selectedKey] : [];

  const menu = [
    {
      label: (
        <NavLink to="/super-admin/dashboard">
          <span>Dashboard</span>
        </NavLink>
      ),
      key: "superAdminDashboard",
      icon: <HomeOutlined />,
    },
    {
      label: (
        <NavLink to="/super-admin/users">
          <span>User Management</span>
        </NavLink>
      ),
      key: "userManagement",
      icon: <UserOutlined />,
    },
    {
      label: (
        <NavLink to="/super-admin/companies">
          <span>Company Management</span>
        </NavLink>
      ),
      key: "companyManagement",
      icon: <ShopOutlined />,
    },
    {
      label: "MASTER DATA",
      key: "masterData",
      icon: <AppstoreOutlined />,
      children: [
        {
          label: (
            <NavLink to="/super-admin/products">
              <span>Products</span>
            </NavLink>
          ),
          key: "products",
          icon: <UnorderedListOutlined />,
        },
        {
          label: (
            <NavLink to="/super-admin/book-publishers">
              <span>Book Publishers</span>
            </NavLink>
          ),
          key: "bookPublishers",
          icon: <BookOutlined />,
        },
        {
          label: (
            <NavLink to="/super-admin/product-categories">
              <span>Product Categories</span>
            </NavLink>
          ),
          key: "productCategories",
          icon: <UnorderedListOutlined />,
        },
        {
          label: (
            <NavLink to="/super-admin/product-currencies">
              <span>Product Currencies</span>
            </NavLink>
          ),
          key: "productCurrencies",
          icon: <DollarOutlined />,
        },
      ],
    },
  ];

  return (
    <div>
      <div
        style={{
          margin: "14px 12px 8px",
          padding: 0,
          background: "transparent",
          border: "none",
          color: "#fff",
          fontWeight: 800,
          letterSpacing: 0.8,
          fontSize: 18,
          whiteSpace: "nowrap",
          textAlign: "center",
        }}
      >
        <span style={{ color: "#ffffff" }}>ER</span>
        <span style={{ color: "#00e5ff" }}>P</span>
      </div>

      <Menu
        theme="dark"
        mode="inline"
        inlineCollapsed={collapsed}
        items={menu}
        className="sidenav-menu"
        selectedKeys={menuSelectedKeys}
        openKeys={openKeys}
        onOpenChange={setOpenKeys}
      />
    </div>
  );
};

export default SuperAdminSidenav;
